export enum OperacaoEnum{

    CARTAO_CREDITO = "CARTAO_CREDITO",
  	CARTAO_DEBITO = "CARTAO_DEBITO",
    PIX = "PIX",
    PAYPAL = "PAYPAL",
    BALANCE_HOTMART = "BALANCE_HOTMART",
    OUTROS = "OUTROS"
  }
